import withWait from './with-wait';
import withCheckSession from './check-session';
import withWorktypesFetch from './worktypes';
import withUserFetch from './user';
import withStepsFetch from './steps';
import withStepsMetaFetch from './stepsmeta';
import withNotificationsFetch from './notifications';
import withNotificationsMetaFetch from './notificationsmeta';
import withActionsFetch from './actions';
import withActionsMetaFetch from './actionsmeta';
import withFacilitatorFetch from './facilitator';
import withSellerFetch from './seller';
import withQueryParamStore from './with-query-param-store';
import withTemplateFolderContents from './templateFiles';
import withDraftData from './draft';
import { withConfirmationTokenRetrieve, withFullConfirmationTokenFetch } from './confirmation-token';
export default (function () {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }
  return subComponent => middlewares.reverse().reduce((item, middleware) => middleware(item), subComponent);
});
export { withWait, withWorktypesFetch, withFullConfirmationTokenFetch, withUserFetch, withStepsFetch, withStepsMetaFetch, withNotificationsFetch, withNotificationsMetaFetch, withActionsFetch, withActionsMetaFetch, withFacilitatorFetch, withSellerFetch, withConfirmationTokenRetrieve, withCheckSession, withQueryParamStore, withTemplateFolderContents, withDraftData };